import React from 'react';
import { Form, Row, Col, Card, Alert } from 'react-bootstrap';
import { useCheckIn } from '../../hooks/useCheckIn';

const ClassSelection: React.FC = () => {
  const { state, toggleClassSelection, resetInteractionTimer } = useCheckIn();

  const handleClassClick = (classId: number, isCheckedIn: boolean) => {
    if (state.selectedStudent && !isCheckedIn) {
      toggleClassSelection(classId);
      resetInteractionTimer();
    }
  };

  // Don't render anything if no student is selected
  if (!state.selectedStudent) {
    return (
      <div className="mb-4" style={{ height: '200px' }} />
    );
  }

  return (
    <div className="mb-4" style={{ height: '200px' }}>
      <Form.Label className="h4 mb-3">Select Your Classes</Form.Label>
      <Row>
        {state.availableClasses.map((classItem) => {
          const isCheckedIn = classItem.checked_in || false;
          const isSelected = state.selectedClasses.includes(classItem.id);

          let cardClass = 'h-100 ';
          if (isCheckedIn) {
            cardClass += 'dark-class-card-disabled';
          } else if (isSelected) {
            cardClass += 'dark-class-card-selected';
          } else {
            cardClass += 'dark-class-card';
          }

          return (
            <Col key={classItem.id} className="mb-3">
              <Card
                className={cardClass}
                onClick={() => handleClassClick(classItem.id, isCheckedIn)}
                style={{
                  cursor: isCheckedIn ? 'not-allowed' : 'pointer',
                  opacity: isCheckedIn ? 0.6 : 1
                }}
              >
                <Card.Body className="text-center p-4">
                  <h5 className="mb-0 fw-bolder position-relative"><span className="fw-lighter">{classItem.time}</span> {classItem.name}</h5>
                  {isCheckedIn && (
                    <h3 className="mb-0 text-success fw-bold mt-3 m position-absolute top-0" style={{'left': '10%'}}>
                      &#10004;
                    </h3>
                  )}
                </Card.Body>
              </Card>
            </Col>
          );
        })}
      </Row>
      
      {state.availableClasses.length === 0 && (
        <Alert variant="info">
          No classes available for this user. Please tell Sensei!
        </Alert>
      )}
    </div>
  );
};

export default ClassSelection;